import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { PaymentsService } from 'src/app/core/services/payments.service';
import { FileService } from 'src/app/core/services/file.service';
import { PaymentsDataService } from 'src/app/core/services/data/payments.data.service';
import { LoadingController, ModalController } from '@ionic/angular';

@Component({
    selector: 'app-payment-success-modal',
    templateUrl: './payment-success-modal.component.html',
    styleUrls: ['./payment-success-modal.component.scss'],
    standalone: false
})
export class PaymentSuccessModalComponent implements OnInit {
  public paymentMethod: string;
  public paymentSuccessful: boolean = false;
  public orderId: string;
  public paymentId: string;
  private loadingIndicatorCompleted: boolean = false;

  private sub: any;
  constructor(
    private modalController: ModalController,
    private paymentsService: PaymentsService,
    private paymentsDataService: PaymentsDataService,
    private fileService: FileService,
    private loadingCtrl: LoadingController
  ) {}

  public ngOnInit(): void {
    this.loadingCtrl
      .create({
        translucent: true,
        cssClass: 'transparent-load-spinner'
      })
      .then((loadingSpinner) => {
        if (!this.loadingIndicatorCompleted) loadingSpinner.present();
      });
    this.paymentsDataService.isPaymentSuccessful.subscribe(
      (isPaymentSuccessful) => {
        this.paymentSuccessful = isPaymentSuccessful;
        this.loadingCtrl.dismiss();
      }
    );
    this.paymentsDataService.receiptOrderId.subscribe((orderId) => {
      this.orderId = orderId;
    });
    this.paymentsDataService.receiptPaymentId.subscribe((paymentId) => {
      this.paymentId = paymentId;
    });
    this.paymentsDataService.paymentMethod.subscribe((paymentMethod) => {
      this.paymentMethod = paymentMethod;
    });
  }

  public getCustomerReceipt(): void {
    if (this.paymentMethod === 'CreditCard') {
      this.getCustomerCreditCardReceipt();
    } else if (this.paymentMethod === 'ECheck') {
      this.getCustomerECheckReceipt();
    } else {
      return;
    }
  }

  public getCustomerCreditCardReceipt() {
    this.paymentsService
      .getCreditCardReceipt(this.orderId, this.paymentId, false)
      .subscribe((receipt) => {
        let base64 = receipt.data[0].documentBase64;
        let fileName = receipt.data[0].filename;
        this.fileService.manageViewFile(base64, fileName);
      });
  }

  public getCustomerECheckReceipt(): void {
    this.paymentsService
      .getECheckReceipt(this.orderId, this.paymentId, false)
      .subscribe((res) => {
        let receipt = res.data;
        this.fileService.manageViewFile(
          receipt[0].documentBase64,
          receipt[0].fileName + '.pdf'
        );
      });
  }

  public dismissPaymentSuccess(): void {
    this.modalController.dismiss();
  }

  ngOnDestry() {
    this.sub.unsubscribe();
  }
}
